import React, { useState, useEffect } from 'react';
import axios from '../Axiosinstance';
import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../common';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Webhead from '../website/Webhead';
import qq from './img/qq.jpeg'
import {
    TextField, Button, Grid, CircularProgress, Slide, Typography, Container, MenuItem, Modal, Box, TableContainer, Select, InputLabel, FormControl, IconButton, Paper, Dialog, DialogActions, DialogContent, DialogTitle, RadioGroup, FormControlLabel, Radio, Card, CardContent, Tooltip, Table, Checkbox, TableRow, TableBody, TableCell, TableHead, Menu, Snackbar, Alert
} from '@mui/material';
import Webfooter from './Webfoot'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';

const Elearn = () => {
    const CLOUDINARY_URL = baseURL;
    const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [profilePicture, setProfilePicture] = useState(null);
    const [nricDocument, setNricDocument] = useState(null);
    const [educationDocument, setEducationDocument] = useState(null);
    const [passportDocument, setPassportDocument] = useState(null);
    const [courses, setCourses] = useState([]);
    const [showEmploymentFields, setShowEmploymentFields] = useState(false); // State to manage visibility of employment fields
    const [open, setOpen] = useState(false);
    const [submissionSuccess, setSubmissionSuccess] = useState(false);
    const [batches, setBatches] = useState([]);
    const navigate = useNavigate();
    const [profileFileName, setProfileFileName] = useState('');
    const [nricFileName, setNricFileName] = useState('');
    const [educationFileName, setEducationFileName] = useState('');
    const [passportFileName, setPassportFileName] = useState('');

    const [studentData, setStudentData] = useState({
        name: '',
        nric: '',
        email: '',
        phone: '',
        gender: '',
        dob: '',

        officephone: '',
        address: '',
        course: '',
        startModulus: null,
        citizenship: '',
        postalcode: '',
        race: '',
        education: '',
        employmentstatus: '',
        salary: '',
        companyname: '',

        designation: '',
        profileUrl: '',
        batchId: null,

        status: false,
        passport: '',
        passportExpiryDate: '',
        fatherName: '',
        brotherName: '',
        fatherPhoneNo: '',
        brotherPhoneNo: '',
        religion: '',
        currentAddress: '',
        institutionDetails: [],
        workExpirences: [],
        emergencyContacts: [],
        nricdoc: '',
        educationdoc: '',
        passportdoc: '',
        postalcode: '',
    });


    useEffect(() => {
        const fetchBatches = async () => {
            try {
                const response = await axios.get("batch-summary"); // API endpoint to get batches
                setBatches(response.data);
            } catch (error) {
                console.error("Error fetching batches:", error);
            }
        };

        fetchBatches();
    }, []);






    const [errors, setErrors] = useState({
        name: "",
        fatherName: "",
        brotherName: "",
        // course: "",
        religion: "",
        citizenship: "",
        nric: "",
        brotherPhoneNo: "",
        officephone: "",
        fatherPhoneNo: "",
    });


    const handleChange = (e) => {
        const { name, value } = e.target;

        console.log(name, value);
        const nricRegex = /^[A-Z]\d{7}[A-Z]$/;

        // Regex to allow only letters and spaces
        const lettersOnlyRegex = /^[a-zA-Z\s]*$/;

        // Regex to allow only numbers
        const onlyNumberRegex = /^[0-9]*$/;

        let errorMessage = "";

        // Check if the field is a text-only field and validate
        if (
            (name === "name" ||
                name === "fatherName" ||
                name === "brotherName" ||
                name === "course" ||
                name === "religion" ||
                name === "citizenship") &&
            !lettersOnlyRegex.test(value)
        ) {
            errorMessage = "Only letters are allowed.";
        }

        if (name === "nric" && value.length === 9 && !nricRegex.test(value)) {
            errorMessage =
                "NRIC must be in the format: 1 capital letter, 7 digits, 1 capital letter (e.g., K1234567H).";
        }

        if (
            (name === "fatherPhoneNo" ||
                name === "officephone" ||
                name === "brotherPhoneNo") &&
            !onlyNumberRegex.test(value)
        ) {
            errorMessage = "Only numbers are allowed.";
        }

        // Update the error state
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage,
        }));

        // If course is selected, find the corresponding currentModule
        if (name === "course") {
            // Find the selected batch details
            const selectedBatch = batches.find((batch) => batch.course === value);
            // setSelectedBatchData(selectedBatch);
            // setInitialModulus(selectedBatch?.currentModule);
            const currentDate = new Date();
            const newModulus = handleDateChange(selectedBatch, currentDate);
            // Update studentData with course, batchId, and currentModule
            setStudentData((prevData) => ({
                ...prevData,
                course: value, // Selected course name
                batchId: selectedBatch?.id || null, // Selected batchId
                startModulus: newModulus || null, // Selected currentModule
            }));
        } else if (!errorMessage) {
            // Update student data only if validation passes
            setStudentData({
                ...studentData,
                [name]: value,
            });
        }
    };


   const handleNricEmailChange = async (e) => {
    const { name, value } = e.target;
    
    // Enforce max length of 9 for NRIC/FIN field
    if (name === 'nric' && value.length > 9) {
        return; // Don't update the state if length exceeds 9
    }
    
    setStudentData((prev) => ({ ...prev, [name]: value }));

    if (value.trim() !== "") {
        try {
            const response = await axios.get(`/registrationadvances/exists?${name}=${value}`);
            if (response.data) {
                setErrors((prev) => ({ ...prev, [name]: `${name.toUpperCase()} already exists!` }));
            } else {
                setErrors((prev) => ({ ...prev, [name]: "" }));
            }
        } catch (error) {
            console.error(`Error checking ${name}:`, error);
            setErrors((prev) => ({ ...prev, [name]: `Error checking ${name}. Try again!` }));
        }
    } else {
        setErrors((prev) => ({ ...prev, [name]: "" }));
    }
};


    useEffect(() => {
        // Log the studentData whenever it changes
        console.log('Updated studentData:', studentData);
    }, [studentData]);

    const handleInstitutionChange = (index, e) => {
        const { name, value } = e.target;
        const newInstitutionDetails = studentData.institutionDetails.map((institution, i) => {
            if (i === index) {
                return { ...institution, [name]: value };
            }
            return institution;
        });
        setStudentData({
            ...studentData,
            institutionDetails: newInstitutionDetails
        });
    };

    const handleAddEducation = () => {
        setStudentData({
            ...studentData,
            institutionDetails: [
                ...studentData.institutionDetails,
                { institution: '', fromYear: '', toYear: '', qualificationsAchieved: '', language: '', highest: false },
            ]
        });
    };


    const handleRemoveEducation = (index) => {
        const newInstitutionDetails = studentData.institutionDetails.filter((_, i) => i !== index);
        setStudentData({ ...studentData, institutionDetails: newInstitutionDetails });
    };

    const handleWorkExperienceChange = (index, e) => {
        const { name, value } = e.target;
        const newWorkExperiences = studentData.workExpirences.map((experience, i) => {
            if (i === index) {
                return { ...experience, [name]: value };
            }
            return experience;
        });
        setStudentData({
            ...studentData,
            workExpirences: newWorkExperiences
        });
    };

    const handleAddWorkExperience = () => {
        setShowEmploymentFields(true);
        setStudentData({
            ...studentData,
            workExpirences: [
                ...studentData.workExpirences,
                { name: '', position: '', fromYear: '', toYear: '', country: '', natureOfPosition: '' }// Add a new empty work experience object
            ]
        });
    };

    const handleRemoveWorkExperience = (index) => {

        const newWorkExperiences = studentData.workExpirences.filter((_, i) => i !== index);
        setStudentData({
            ...studentData,
            workExpirences: newWorkExperiences
        });
    };


    const handleEmergencyChange = (index, field, value) => {
        const updatedContacts = [...studentData.emergencyContacts];
        updatedContacts[index][field] = value;
        setStudentData({ ...studentData, emergencyContacts: updatedContacts });
    };

    const handleAddEmergency = () => {
        setStudentData({
            ...studentData,
            emergencyContacts: [
                ...studentData.emergencyContacts,
                { name: '', number: '', relationship: '', othersRelationship: '' },
            ],
        });
    };

    const handleRemoveEmergency = (index) => {
        const updatedContacts = [...studentData.emergencyContacts];
        updatedContacts.splice(index, 1);
        setStudentData({ ...studentData, emergencyContacts: updatedContacts });
    };

    const handleFileChange = (
        setter,
        allowedTypes,
        fieldName,
        allowedFormatsText,
        setFileName
    ) => (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > 8 * 1024 * 1024) {
            event.target.value = '';
            toast.error('Max file size 8MB');
            return;
        }

        if (!allowedTypes.includes(file.type)) {
            event.target.value = '';
            toast.error(`${fieldName}: Only ${allowedFormatsText}`);
            return;
        }

        setter(file);
        setFileName(file.name);
    };



    const uploadFile = async (file, publicId) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', CLOUDINARY_UPLOAD);
        formData.append('public_id', publicId + ' - ' + timestamp);

        const response = await fetch(baseURL, {
            method: 'POST',
            body: formData,
        });

        const data = await response.json();
        if (!data.secure_url) {
            throw new Error('Failed to upload file.');
        }
        return data.secure_url;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsUploading(true);
         const highestCount = studentData.institutionDetails.filter(inst => inst.highest).length;
        if (highestCount !== 1) {
            toast.error("Please select exactly one 'Highest Qualification'.");
            return;
        }
        try {
            const enrollmentDate = new Date().toISOString().split('T')[0];
            const offerDate = new Date().toISOString().split('T')[0];

            const profileUrl = profilePicture
                ? await uploadFile(profilePicture, `LMS/RequestStudent/Profile/${profilePicture.name}`)
                : '';
            const nricdoc = nricDocument
                ? await uploadFile(nricDocument, `LMS/RequestStudent/Nric/${nricDocument.name}`)
                : '';
            const educationdoc = educationDocument
                ? await uploadFile(educationDocument, `LMS/RequestStudent/Education/${educationDocument.name}`)
                : '';
            const passportdoc = passportDocument
                ? await uploadFile(passportDocument, `LMS/RequestStudent/Passport/${passportDocument.name}`)
                : '';

            const updatedStudentData = {
                ...studentData,
                profileUrl,
                nricdoc,
                educationdoc,
                passportdoc,
                enrollmentDate,
                offerDate,
                password: studentData?.nric,
            };

            const response = await axios.post('/registrationadvances', updatedStudentData);
            setSubmissionSuccess(true);
            toast.success('Submission successful!');

            setTimeout(() => {
                navigate('/');
            }, 3000);
        } catch (error) {
            console.error('Submission failed:', error);
            toast.error('Submission failed. Please try again.');
        } finally {
            setIsUploading(false);
        }
    };


    const dayMapping = {
        'Sunday': 0,
        'Monday': 1,
        'Tuesday': 2,
        'Wednesday': 3,
        'Thursday': 4,
        'Friday': 5,
        'Saturday': 6
    };

    const handleDateChange = (batch, currentDate) => {

        const newDate = dayjs(currentDate); // Create dayjs object from the new date

        const intakeStartDate = batch?.intakeStartDate ? dayjs(batch.intakeStartDate) : null;
        const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);

        if (batch?.status && !isDatePassed) {

            console.log("Batch is active. Using current module:", batch?.currentModule);
            return batch.currentModule; // Exit function
        }


        const oldDate = dayjs();

        console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
        console.log("New Date:", newDate.format('YYYY-MM-DD'));

        // Calculate the difference in months between the old and new dates
        let monthDifference = newDate.month() - oldDate.month();
        if (newDate.year() !== oldDate.year()) {
            monthDifference += (newDate.year() - oldDate.year()) * 12;
        }
        console.log("Month Difference:", monthDifference);

        // For advance diploma, the increment is simply the month difference
        let increment = monthDifference;
        console.log("Advance Diploma Course - Increment:", increment);

        // Calculate the new modulus value based on the increment
        let newModulus = batch.currentModule + increment;
        // Wrap around to keep it between 1 and 12 (instead of 1 and 6)
        newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;
        console.log("New Modulus Before Ensuring Range:", newModulus);

        const firstDay = batch.days[0]; // Assuming days is in the correct scope
        console.log("First Day from Data:", firstDay.day);

        const dayIndex = dayMapping[firstDay.day];
        // Determine the first occurrence of the specified day of the month
        const firstOfMonth = newDate.date(1); // Set to the first of the month
        let firstSpecifiedDay = firstOfMonth.day(dayIndex); // Find the first occurrence

        // If the first occurrence is in the previous month, move to the next week
        if (firstSpecifiedDay.isBefore(firstOfMonth)) {
            firstSpecifiedDay = firstSpecifiedDay.add(1, 'week');
        }

        console.log("First Specified Day of the Month:", firstSpecifiedDay.format('YYYY-MM-DD'));

        // Adjust modulus: if the enrollment date is after the first specified day,
        // add 1 to the new modulus.
        if (newDate.isAfter(firstSpecifiedDay)) {
            newModulus += 1;
            console.log("Adjusting Modulus by adding 1.");
        }

        // Ensure modulus value stays within the 1-12 range after adjustments
        newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;


        console.log("newModulus", newModulus)
        return newModulus;

    };


    return (
        <div>
            {/* <Webhead /> */}

            <Box>
                <Box
                    sx={{
                        backgroundImage: `url(${qq})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        py: 8,
                        textAlign: 'center',
                        color: 'white',
                    }}
                >
                    <Typography variant="h2" color="white" sx={{ fontWeight: 700 }}>
                        Online Student Portal
                    </Typography>
                </Box>

                <Container maxWidth="lg" sx={{ py: 4 }}>
                    <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
                        <Typography variant="h4" align="center" gutterBottom sx={{ mb: 4, color: 'primary.main' }}>
                            Online Registration Form
                        </Typography>

                        <form onSubmit={handleSubmit}>
                            {/* Personal Information Section */}
                            <Box sx={{ mb: 4 }}>
                                <Typography variant="h6" gutterBottom sx={{ borderBottom: '1px solid #eee', pb: 1, mb: 2 }}>
                                    Personal Information
                                </Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Name"
                                            name="name"
                                            value={studentData.name}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="NRIC/FIN No"
                                            name="nric"
                                            value={studentData.nric}
                                            onChange={handleNricEmailChange}
                                            required
                                            variant="outlined"
                                            error={!!errors.nric}
                                            helperText={errors.nric}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Email"
                                            type="email"
                                            name="email"
                                            value={studentData.email}
                                            onChange={handleNricEmailChange}
                                            required
                                            variant="outlined"
                                            error={!!errors.email}
                                            helperText={errors.email}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Postal Code"
                                            name="postalcode"
                                            value={studentData.postalcode}
                                            onChange={(e) => {
                                                const input = e.target.value;
                                                if (/^\d{0,6}$/.test(input)) {
                                                    handleChange(e);
                                                }
                                            }}
                                            required
                                            variant="outlined"
                                            inputProps={{ maxLength: 6 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Passport Number"
                                            name="passport"
                                            value={studentData.passport}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Passport Expiry Date"
                                            type="date"
                                            name="passportExpiryDate"
                                            value={studentData.passportExpiryDate}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Citizenship"
                                            name="citizenship"
                                            value={studentData.citizenship}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Course"
                                            select
                                            name="course"
                                            value={studentData.course}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                        >
                                            <MenuItem value="">Select Course...</MenuItem>
                                            {batches.map((batch) => (
                                                <MenuItem key={batch.id} value={batch.course}>
                                                    {batch.course}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Gender"
                                            select
                                            name="gender"
                                            value={studentData.gender}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                        >
                                            <MenuItem value="">Select...</MenuItem>
                                            <MenuItem value="Male">Male</MenuItem>
                                            <MenuItem value="Female">Female</MenuItem>
                                            <MenuItem value="Other">Other</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Date of Birth"
                                            type="date"
                                            name="dob"
                                            value={studentData.dob}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Hand Phone"
                                            type="tel"
                                            name="phone"
                                            value={studentData.phone}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                            inputProps={{ maxLength: 20 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Office Phone"
                                            type="tel"
                                            name="officephone"
                                            value={studentData.officephone}
                                            onChange={handleChange}
                                            variant="outlined"
                                            inputProps={{ maxLength: 20 }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Singapore Address"
                                            name="currentAddress"
                                            value={studentData.currentAddress}
                                            onChange={handleChange}
                                            variant="outlined"

                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Home Address"
                                            name="address"
                                            value={studentData.address}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required


                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Religion"
                                            name="religion"
                                            value={studentData.religion}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                        />
                                    </Grid>
                                </Grid>
                            </Box>

                            {/* Document Upload Section */}
                            <Box sx={{ mb: 4 }}>
                                <Typography variant="h6" gutterBottom sx={{ borderBottom: '1px solid #eee', pb: 1, mb: 2 }}>
                                    Document Uploads
                                </Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={3}>
                                        <Box>
                                            <Typography variant="body2" gutterBottom>Upload Photo*</Typography>
                                            <Button
                                                variant="outlined"
                                                component="label"
                                                fullWidth
                                                startIcon={<CloudUploadIcon />}
                                            >
                                                Select File
                                                <input
                                                    type="file"
                                                    hidden
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    onChange={handleFileChange(
                                                        setProfilePicture,
                                                        ['image/png', 'image/jpeg', 'image/jpg'],
                                                        'Profile Photo',
                                                        'PNG, JPG, JPEG',
                                                        setProfileFileName
                                                    )}
                                                />
                                            </Button>
                                            <Typography variant="caption" color="textSecondary">
                                                {profileFileName || 'PNG, JPG, JPEG'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Box>
                                            <Typography variant="body2" gutterBottom>Upload NRIC*</Typography>
                                            <Button
                                                variant="outlined"
                                                component="label"
                                                fullWidth
                                                startIcon={<CloudUploadIcon />}
                                            >
                                                Select File
                                                <input
                                                    type="file"
                                                    hidden
                                                    accept="application/pdf"
                                                    onChange={handleFileChange(
                                                        setNricDocument,
                                                        ['application/pdf'],
                                                        'NRIC Document',
                                                        'PDF',
                                                        setNricFileName
                                                    )}
                                                />
                                            </Button>
                                            <Typography variant="caption" color="textSecondary">
                                                {nricFileName || 'PDF only'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Box>
                                            <Typography variant="body2" gutterBottom>Upload Education*</Typography>
                                            <Button
                                                variant="outlined"
                                                component="label"
                                                fullWidth
                                                startIcon={<CloudUploadIcon />}
                                            >
                                                Select File
                                                <input
                                                    type="file"
                                                    hidden
                                                    accept="application/pdf"
                                                    onChange={handleFileChange(
                                                        setEducationDocument,
                                                        ['application/pdf'],
                                                        'Education Document',
                                                        'PDF',
                                                        setEducationFileName
                                                    )}
                                                />
                                            </Button>
                                            <Typography variant="caption" color="textSecondary">
                                                {educationFileName || 'PDF only'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Box>
                                            <Typography variant="body2" gutterBottom>Upload Passport*</Typography>
                                            <Button
                                                variant="outlined"
                                                component="label"
                                                fullWidth
                                                startIcon={<CloudUploadIcon />}
                                            >
                                                Select File
                                                <input
                                                    type="file"
                                                    hidden
                                                    accept="application/pdf"
                                                    onChange={handleFileChange(
                                                        setPassportDocument,
                                                        ['application/pdf'],
                                                        'Passport Document',
                                                        'PDF',
                                                        setPassportFileName
                                                    )}
                                                />
                                            </Button>
                                            <Typography variant="caption" color="textSecondary">
                                                {passportFileName || 'PDF only'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>

                            {/* Additional Sections */}
                            <Box sx={{ mb: 4 }}>
                                {/* Action Buttons */}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 2,
                                        mb: 3,
                                        justifyContent: { xs: 'center', sm: 'flex-start' }
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        startIcon={<AddIcon />}
                                        onClick={handleAddEducation}
                                        sx={{ minWidth: '200px' }}
                                    >
                                        Add Education
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<AddIcon />}
                                        onClick={handleAddWorkExperience}
                                        sx={{ minWidth: '200px' }}
                                    >
                                        Add Employment
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<AddIcon />}
                                        onClick={handleAddEmergency}
                                        sx={{ minWidth: '200px' }}
                                    >
                                        Add Emergency Contact
                                    </Button>
                                </Box>

                                {/* Three Equal Columns */}
                                <Grid container spacing={3}>
                                    {/* Education Column */}
                                    {studentData.institutionDetails.map((institution, index) => (
                                        <Grid item xs={12} md={4}>
                                            <Paper sx={{ p: 2, height: '100%' }}>
                                                <Typography variant="h6" gutterBottom sx={{ mb: 2, color: 'secondary.main' }}>
                                                    Education History
                                                </Typography>

                                                <Paper
                                                    key={index}
                                                    sx={{
                                                        p: 2,
                                                        mb: 2,
                                                        borderLeft: '4px solid',
                                                        borderColor: 'secondary.main',
                                                        backgroundColor: 'background.paper'
                                                    }}
                                                >
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Typography variant="subtitle1">
                                                            Education {index + 1}
                                                        </Typography>
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => handleRemoveEducation(index)}
                                                            size="small"
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>

                                                    <Grid container spacing={1} sx={{ mt: 1 }}>
                                                        <Grid item xs={12}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={institution.highest || false}
                                                                        onChange={(e) => {
                                                                            const updatedInstitutions = studentData.institutionDetails.map((inst, i) => ({
                                                                                ...inst,
                                                                                highest: i === index ? e.target.checked : false,
                                                                            }));
                                                                            setStudentData({ ...studentData, institutionDetails: updatedInstitutions });
                                                                        }}
                                                                        size="small"
                                                                    />
                                                                }
                                                                label="Highest qualification"
                                                                sx={{ mb: 1 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Institution Name"
                                                                name="institution"
                                                                value={institution.institution}
                                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Language of Instruction"
                                                                name="language"
                                                                value={institution.language}
                                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Degree/Qualification"
                                                                name="qualificationsAchieved"
                                                                value={institution.qualificationsAchieved}
                                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="From Year"
                                                                type="number"
                                                                name="fromYear"
                                                                value={institution.fromYear}
                                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="To Year"
                                                                type="number"
                                                                name="toYear"
                                                                value={institution.toYear}
                                                                onChange={(e) => handleInstitutionChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Paper>

                                            </Paper>
                                        </Grid>
                                    ))}

                                    {/* Employment Column */}
                                    {showEmploymentFields && studentData.workExpirences.map((experience, index) => (
                                        <Grid item xs={12} md={4}>
                                            <Paper sx={{ p: 2, height: '100%' }}>
                                                <Typography variant="h6" gutterBottom sx={{ mb: 2, color: 'primary.main' }}>
                                                    Employment History
                                                </Typography>

                                                <Paper
                                                    key={index}
                                                    sx={{
                                                        p: 2,
                                                        mb: 2,
                                                        borderLeft: '4px solid',
                                                        borderColor: 'primary.main',
                                                        backgroundColor: 'background.paper'
                                                    }}
                                                >
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Typography variant="subtitle1">
                                                            Employment {index + 1}
                                                        </Typography>
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => handleRemoveWorkExperience(index)}
                                                            size="small"
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>

                                                    <Grid container spacing={1} sx={{ mt: 1 }}>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Company Name"
                                                                name="name"
                                                                value={experience.name}
                                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Position"
                                                                name="position"
                                                                value={experience.position}
                                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Country"
                                                                name="country"
                                                                value={experience.country}
                                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Nature of Duties"
                                                                name="natureOfPosition"
                                                                value={experience.natureOfPosition}
                                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="From Year"
                                                                type="number"
                                                                name="fromYear"
                                                                value={experience.fromYear}
                                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="To Year"
                                                                type="number"
                                                                name="toYear"
                                                                value={experience.toYear}
                                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                                required
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Paper>

                                            </Paper>
                                        </Grid>
                                    ))}

                                    {/* Emergency Contacts Column */}
                                    {studentData.emergencyContacts.map((contact, index) => (
                                        <Grid item xs={12} md={4}>
                                            <Paper sx={{ p: 2, height: '100%' }}>
                                                <Typography variant="h6" gutterBottom sx={{ mb: 2, color: 'error.main' }}>
                                                    Emergency Contacts
                                                </Typography>

                                                <Paper
                                                    key={index}
                                                    sx={{
                                                        p: 2,
                                                        mb: 2,
                                                        borderLeft: '4px solid',
                                                        borderColor: 'error.main',
                                                        backgroundColor: 'background.paper'
                                                    }}
                                                >
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Typography variant="subtitle1">
                                                            Contact {index + 1}
                                                        </Typography>
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => handleRemoveEmergency(index)}
                                                            size="small"
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>

                                                    <Grid container spacing={1} sx={{ mt: 2 }}>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Relationship"
                                                                select
                                                                value={contact.relationship}
                                                                onChange={(e) => handleEmergencyChange(index, 'relationship', e.target.value)}
                                                                required
                                                            >
                                                                <MenuItem value="">Select Relationship</MenuItem>
                                                                <MenuItem value="Father">Father</MenuItem>
                                                                <MenuItem value="Mother">Mother</MenuItem>
                                                                <MenuItem value="Brother">Brother</MenuItem>
                                                                <MenuItem value="Sister">Sister</MenuItem>
                                                                <MenuItem value="Others">Others</MenuItem>
                                                            </TextField>
                                                        </Grid>
                                                        {contact.relationship === 'Others' && (
                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    label="Specify Relationship"
                                                                    value={contact.othersRelationship}
                                                                    onChange={(e) => handleEmergencyChange(index, 'othersRelationship', e.target.value)}
                                                                    required
                                                                />
                                                            </Grid>
                                                        )}
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Name"
                                                                value={contact.name}
                                                                onChange={(e) => handleEmergencyChange(index, 'name', e.target.value)}
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label="Contact No"
                                                                type="tel"
                                                                value={contact.number}
                                                                onChange={(e) => handleEmergencyChange(index, 'number', e.target.value)}
                                                                required
                                                                inputProps={{ maxLength: 10 }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Paper>

                                            </Paper>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>

                            {/* Submit Button */}
                            <Box sx={{ display: 'flex', justifyContent: 'end', mt: 4 }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    disabled={isUploading}
                                    startIcon={isUploading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                                >
                                    {isUploading ? 'Submitting...' : 'Submit Application'}
                                </Button>
                            </Box>
                        </form>
                    </Paper>
                </Container>

                <Dialog
                    open={open}
                    onClose={() => setOpen(false)}
                    maxWidth="sm"
                    PaperProps={{ style: { borderRadius: 15 } }}
                >
                    <DialogContent>
                        {submissionSuccess ? (
                            <Slide direction="up" in={submissionSuccess} mountOnEnter unmountOnExit>
                                <Box textAlign="center" py={4}>
                                    <CheckCircleIcon sx={{ fontSize: 60, color: 'success.main' }} />
                                    <Typography variant="h5" gutterBottom>
                                        Form Submitted Successfully!
                                    </Typography>
                                    <Typography variant="body1" color="textSecondary">
                                        You will receive an email once your application is approved.
                                    </Typography>
                                </Box>
                            </Slide>
                        ) : (
                            <Box textAlign="center" py={4}>
                                <CircularProgress />
                                <Typography variant="h6" sx={{ mt: 2 }}>
                                    Submitting Your Form...
                                </Typography>
                            </Box>
                        )}
                    </DialogContent>
                </Dialog>

                <ToastContainer />
            </Box>
            <Webfooter />
        </div>
    );
};

export default Elearn;
